// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__RzzEX","section__animation--in":"Section_section__animation--in__P2hiw"};